import React from 'react';
import './styles.css';

const About = () => {
    return (
        <>
            <div class="main column col">
                <div class="banner mt-1">
                    <img class="image-fluid" src="./images/Pipeflare-promo-banner_728x90.jpg" width="100%" alt="" />
                </div>

            
                <div class="container mt-5">                    
                        <div class="credits-header">
                            <h1 class="display-4 ">About This Site</h1>
                        </div>

                        <div class="row">
                            <div class="w-100 mt-5">
                                <p class="text-muted about-text">
                                    This is an unfunded, non-organizational website. This website is not related to any websites that are listed here.
                                </p>

                                <p class="text-muted about-text">
                                    This website serves as a bookmark. Instead of saving those <strong>Faucet Sites</strong>, <strong>PTC Sites</strong> or any websites to browser's bookmark,
                                    I created this website for personal use where all the websites that I am visiting are stored here and now I am opening this to public so that
                                    people who wants to use this site will don't have to bookmark anymore.
                                </p>

                                <p class="text-muted about-text">
                                    By using this website you agree to the <strong>Terms</strong> and <strong>Conditions</strong>.
                                </p>
                            </div>
                        </div>
                </div>
        </div>  
        </>
    );
};
export default About;